import { useEffect, useRef, useState } from 'react';
import DOMPurify from 'dompurify';

// import utils
import {
  addListenersToRefLinks,
  removeListenersFromRefLinks
} from '@utils/analytics/addListenersToRefLinks';

function useTextEditorContent(editorState, handleLinkTracking, paragraphImages ) {
  const editorTextRef = useRef();
  const [ linkData, setLinkData ] = useState([]);

  // side effects
  useEffect( () => {
    if (editorState !== null) {
      let counter = 1;

      if (editorTextRef.current) {
        const el = editorTextRef.current;
        // set content of editorTextRef
        el.innerHTML = DOMPurify.sanitize(editorState) || '';

        // loop through nodes and replace image with correct source.
        if (paragraphImages !== undefined) {
          paragraphImages.forEach((paragraphimageObj, imgIdx) => {
            if (el.getElementsByTagName('img').length >= counter) {
              const textImage = el.getElementsByTagName('img')[imgIdx];
              textImage.src = paragraphimageObj;
              counter++;
            }
          });
        }
        // add click event listeners to links
        if (handleLinkTracking) {
          setLinkData(addListenersToRefLinks(el, handleLinkTracking));
        }
      }
    }
    // hack for Reel apps to notify webview of height change.
    if (window.ScreenKit && window.ScreenKit.notifyOfHeightChange) {
      const newWebviewHeight = document.documentElement.scrollHeight;
      window.ScreenKit.notifyOfHeightChange(newWebviewHeight);

      setTimeout( () => {
        const newWebviewHeight2 = document.documentElement.scrollHeight;
        window.ScreenKit.notifyOfHeightChange(newWebviewHeight2);
      }, 200);
    }

    // remove click event listeners on unmount
    return () => {
      if (linkData && linkData.length) {
        removeListenersFromRefLinks(linkData);
      }
    };

  }, [ editorState, paragraphImages, editorTextRef ]); // eslint-disable-line react-hooks/exhaustive-deps

  return editorTextRef;
}

export default useTextEditorContent;
